<h1>Company nav</h1>
<ul>
    <li><a [routerLink]="['dashboard']">Dashboard</a></li>
   <li><a [routerLink]="['assets']">Assets</a></li>
    <li><a [routerLink]="['accruals-prepayments']">Accruals and prepayments</a></li>
    <li><a [routerLink]="['loans']">Loans</a></li>
</ul>